export enum PatientRegisterType {
    Patient = 1,
    EarlyDetection = 2,
    UnknownPatient = 3,
    HospitalStaff = 4,
    HeadOfFamily = 5,
}